export default __webpack_public_path__ + "static/media/argentan5.18804eea.jpg";